import {Component, Input, OnInit} from '@angular/core';
import {Tile} from "../../Tile";
import {interval, Subscription} from "rxjs";
import {AnalogInRawValueDataservice} from "../AnalogInRawValueDataservice";
import {MeasurementDescriptionDataservice} from "../../measurements/MeasurementDescriptionDataservice";
import {AnalogindetailsComponent} from "../analogindetails/analogindetails.component";
import {environment} from "../../../environments/environment";
import {AiRaw, AiRawList} from "../AiRawList";
import {MeasurementDescription, MeasurementDescriptionList} from "../../measurements/MeasurementDescriptionList";

@Component({
  selector: 'app-analoginlist',
  templateUrl: './analoginlist.component.html',
  styleUrls: ['./analoginlist.component.css']
})
export class AnaloginlistComponent implements OnInit {
  tiles: Tile[] = [
    {text: 'Tile 1', cols: 1, rows: 8, color: 'lightblue', border: '3px double purple'},
    {text: 'Tile 2', cols: 1, rows: 8, color: 'lightblue', border: '3px double red'},
    {text: 'Tile 3', cols: 1, rows: 8, color: 'lightblue', border: '3px double skyblue'},
    {text: 'Tile 4', cols: 1, rows: 8, color: 'lightblue', border: '3px double yellow'},
  ];

  @Input()
  measurementDescriptionList: MeasurementDescriptionList | undefined;
  analogInRawList: AiRawList | undefined;
  private updateSubscription: Subscription | undefined;
  errorMessage: string = "";
  componentList = Array<AnalogindetailsComponent>();
  public loaderStatus: number = 0;


  constructor(private measurementDescriptionDataservice: MeasurementDescriptionDataservice,
              private analogInRawValueDataservice: AnalogInRawValueDataservice) {
  }

  InitLayout(): void {
    this.measurementDescriptionDataservice.GetData().subscribe({
      next: measurementDescriptionList => {
        this.measurementDescriptionList = measurementDescriptionList;
        this.componentList.forEach((detail => {
          detail.UpdateLayoutData(this.GetDescription(detail.GetFullChannel()));
        }))
      },
      error: err => this.errorMessage = err
    });
  }

  ReSubscribe(): void{
    this.updateSubscription = interval(environment.interval).subscribe(
      () => {
        this.UpdateData();
      });
  }

  UpdateData(): void {
    this.updateSubscription?.unsubscribe();
    this.loaderStatus = -1;
    this.analogInRawValueDataservice.GetData().subscribe(
      {
        next: aiRawList => {
          this.loaderStatus = 1;
          // Copy the WHOLE list into this class
          this.analogInRawList = aiRawList;
          // Now parse all member for an update
          for(let detail of this.componentList) {
            detail.UpdateAiRaw(this.GetAiRaw(detail.refNumber));
          }
          this.ReSubscribe();
        }, error: err => this.errorMessage = err
      });
  }


  ngOnInit(): void {
    this.InitLayout();
    this.UpdateData();
  }

  ngOnDestroy(): void {
    this.updateSubscription?.unsubscribe();
  }

  Add(analogInDetail: AnalogindetailsComponent): void {
    this.componentList.push(analogInDetail);
  }

  GetDescription(refNumber: number): MeasurementDescription {
    if ((this.measurementDescriptionList) && (this.measurementDescriptionList.MeasurementDescription[refNumber]))
      return this.measurementDescriptionList.MeasurementDescription[refNumber];
    return new MeasurementDescription();
  }

  GetAiRaw(refNumber: number): AiRaw {
    if ((this.analogInRawList) && (this.analogInRawList.AiRaw[refNumber]))
      return this.analogInRawList.AiRaw[refNumber];
    return new AiRaw();
  }

  counter(i: number) {
    return new Array(i);
  }
}


